import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Checkbox } from '../../atoms/legacy-checkbox/checkbox';
import { Label } from '../label/label';
import { FieldFooter } from '../legacy-field-footer/field-footer';
import styles from './checkbox.module.scss';
/**
 * @deprecated Use `Checkbox` instead.
 */ export const CheckboxInput = ({ 'data-testid': dataTestId, hasBoldLabel, hasError, isDisabled, label, labelSlot, name, statusLabel, value, ...props })=>{
    const id = value ? `${name}_${value}` : name;
    const labelId = id && `${id}_label`;
    const statusId = id && `${id}_validationMessage`;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.wrapper,
        children: [
            /*#__PURE__*/ _jsx(Checkbox, {
                "aria-describedby": statusId,
                "aria-invalid": hasError,
                "aria-labelledby": labelId,
                "data-testid": dataTestId,
                disabled: isDisabled,
                id: id,
                name: name,
                value: value,
                ...props,
                className: classNames(styles.checkbox, props.className),
                state: hasError ? 'error' : isDisabled ? 'disabled' : 'default'
            }),
            /*#__PURE__*/ _jsxs(Label, {
                bold: hasBoldLabel,
                className: classNames(styles.label, isDisabled && styles['label-disabled']),
                htmlFor: id,
                id: labelId,
                children: [
                    label ?? labelSlot,
                    statusLabel && /*#__PURE__*/ _jsx(FieldFooter, {
                        id: statusId,
                        label: statusLabel,
                        state: hasError ? 'error' : 'default'
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=checkbox-input.js.map